export default __webpack_public_path__ + "static/x10-b60d3421071469cf9b606137f2b54fbc.png";